import { normalize, schema } from 'normalizr'

const problem = new schema.Entity('problems')
const location = new schema.Entity('locations', { problems: [problem] })
const category = new schema.Entity('categories', { problems: [problem] })

export const normalizeMaintenanceLocations = locations =>
  normalize(locations, [location]).entities

export const normalizeMaintenanceCategories = categories =>
  normalize(categories, [category]).entities
